'use es6';

import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import FilterEditorFieldSelect from './FilterEditorFieldSelect';
export default class FilterEditorEntitySelect extends FilterEditorFieldSelect {
  constructor(...args) {
    super(...args);
    this.handleFieldChange = field => {
      const {
        onChange
      } = this.props;
      onChange(syntheticEvent(field));
    };
  }
}